import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { runDevGuard, detectDevGuardIssue } from "@/lib/devGuard";
import { DevGuardBanner } from "@/components/DevGuardBanner";

// Guard dev-time: rileva configurazioni incoerenti (URL backend cross-origin
// senza proxy) che causerebbero il blocco silenzioso dei cookie SameSite=Lax.
// No-op in produzione.
runDevGuard();
const devGuardIssue = detectDevGuardIssue();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
if (devGuardIssue && devGuardIssue.severity === "critical") {
  // Config dev incoerente: mostra banner bloccante full-screen,
  // NON avviare l'app. Evita ore di debugging su 401 silenziosi.
  root.render(
    <React.StrictMode>
      <DevGuardBanner issue={devGuardIssue} />
    </React.StrictMode>,
  );
} else {
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </React.StrictMode>,
  );
}
